import { useMemo } from 'react'

import { SummaryWrap, SummaryItem } from 'app/common/templates-next/report-template/summary'
import { SummaryRow } from 'app/components/common/reports/summary'
import { SubsidyGroupedSummaryType } from 'app/dataTypes/reports/data/common/subsidies/grouped'

type SummaryValue = string | Array<string>
type SummaryRowData = Array<[string, SummaryValue]>

type SummaryKey =
  | 'klassesSum'
  | 'klassesCount'
  | 'dayCaresSum'
  | 'dayCaresCount'
  | 'sum'
  | 'count'

const translate = (key: SummaryKey): string => {
  if (key === 'klassesSum') {
    return 'Итого в классах'
  }
  if (key === 'klassesCount') {
    return 'Кол-во учащихся в классах'
  }
  if (key === 'dayCaresSum') {
    return 'Итого в ГПД'
  }
  if (key === 'dayCaresCount') {
    return 'Кол-во учащихся в ГПД'
  }
  if (key === 'sum') {
    return 'ИТОГО'
  }
  if (key === 'count') {
    return 'Кол-во учащихся'
  }

  return undefined as never
}

const withCurrency = (value: string | undefined, currency: string) => `${value || '0,00'} ${currency}`

type Props = {
  summary: SubsidyGroupedSummaryType
  currency: string
  pending?: boolean
}

export const Summary = ({ summary, currency, pending }: Props) => {
  const rows = useMemo<Array<SummaryRowData>>(() => {
    const {
      sum,
      count,
      klasses,
      dayCares,
    } = summary || {}

    const row1: SummaryRowData = [
      [translate('klassesSum'), withCurrency(klasses?.sum, currency)],
      [translate('klassesCount'), String(klasses?.count ?? 0)],
      [translate('dayCaresSum'), withCurrency(dayCares?.sum, currency)],
      [translate('dayCaresCount'), String(dayCares?.count ?? 0)],
    ]

    const row2: SummaryRowData = [
      [translate('sum'), withCurrency(sum, currency)],
      [translate('count'), String(count ?? 0)],
    ]

    return [row1, row2]
  }, [summary, currency])

  return (
    <SummaryWrap>
      {rows.map((row, i) => (
        <SummaryRow key={i}>
          {row.map(([title, value]) => (
            <SummaryItem
              key={title}
              title={title}
              value={value}
              pending={pending}
            />
          ))}
        </SummaryRow>
      ))}
    </SummaryWrap>
  )
}
